import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from '../pages/LandingPage';
import Dashboard from '../pages/Dashboard';
import Feed from '../pages/Feed';
import Profile from '../pages/Profile';
import Connections from '../pages/Connections';
import Explore from '../pages/Explore';
import Search from '../pages/Search';
import Messages from '../pages/Messages';
import Live from '../pages/Live';
import GoLive from '../pages/GoLive';
import CreatorsHub from '../pages/CreatorsHub';
import Verification from '../pages/Verification';
import Bookmarks from '../pages/Bookmarks';
import SongPosts from '../pages/SongPosts';
import Scheduled from '../pages/Scheduled';
import Arena from '../pages/Arena';
import SpectatorView from '../pages/SpectatorView';
import PointClips from '../pages/PointClips';
import Settings from '../pages/Settings';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import TermsOfUse from '../pages/TermsOfUse';
import Wallet from '../pages/Wallet';
import CreatorSetup from '../pages/CreatorSetup';

const ProtectedRoute = ({ isAuth, children }) => isAuth ? children : <Navigate to="/" />;

const AppRoutes = ({ isAuthenticated, setIsAuthenticated }) => (
  <Routes>
    <Route path="/" element={!isAuthenticated ? <LandingPage setIsAuthenticated={setIsAuthenticated} /> : <Navigate to="/dashboard" />} />
    <Route path="/dashboard" element={<ProtectedRoute isAuth={isAuthenticated}><Dashboard /></ProtectedRoute>} />
    <Route path="/feed" element={<ProtectedRoute isAuth={isAuthenticated}><Feed /></ProtectedRoute>} />
    <Route path="/explore" element={<ProtectedRoute isAuth={isAuthenticated}><Explore /></ProtectedRoute>} />
    <Route path="/search" element={<ProtectedRoute isAuth={isAuthenticated}><Search /></ProtectedRoute>} />
    <Route path="/messages" element={<ProtectedRoute isAuth={isAuthenticated}><Messages /></ProtectedRoute>} />
    <Route path="/profile" element={<ProtectedRoute isAuth={isAuthenticated}><Profile /></ProtectedRoute>} />
    <Route path="/profile/:userId" element={<ProtectedRoute isAuth={isAuthenticated}><Profile /></ProtectedRoute>} />
    <Route path="/hashtag/:tag" element={<ProtectedRoute isAuth={isAuthenticated}><Search /></ProtectedRoute>} />
    <Route path="/connections" element={<ProtectedRoute isAuth={isAuthenticated}><Connections /></ProtectedRoute>} />
    <Route path="/live/:streamId" element={<ProtectedRoute isAuth={isAuthenticated}><Live /></ProtectedRoute>} />
    <Route path="/go-live" element={<ProtectedRoute isAuth={isAuthenticated}><GoLive /></ProtectedRoute>} />
    <Route path="/creators" element={<ProtectedRoute isAuth={isAuthenticated}><CreatorsHub /></ProtectedRoute>} />
    <Route path="/verification" element={<ProtectedRoute isAuth={isAuthenticated}><Verification /></ProtectedRoute>} />
    <Route path="/bookmarks" element={<ProtectedRoute isAuth={isAuthenticated}><Bookmarks /></ProtectedRoute>} />
    <Route path="/music/:songId" element={<ProtectedRoute isAuth={isAuthenticated}><SongPosts /></ProtectedRoute>} />
    <Route path="/scheduled" element={<ProtectedRoute isAuth={isAuthenticated}><Scheduled /></ProtectedRoute>} />
    <Route path="/arena" element={<ProtectedRoute isAuth={isAuthenticated}><Arena /></ProtectedRoute>} />
    <Route path="/arena/:debateId" element={<ProtectedRoute isAuth={isAuthenticated}><SpectatorView /></ProtectedRoute>} />
    <Route path="/clips" element={<ProtectedRoute isAuth={isAuthenticated}><PointClips /></ProtectedRoute>} />
    <Route path="/wallet" element={<ProtectedRoute isAuth={isAuthenticated}><Wallet /></ProtectedRoute>} />
    <Route path="/creator" element={<ProtectedRoute isAuth={isAuthenticated}><CreatorSetup /></ProtectedRoute>} />
    <Route path="/settings" element={<ProtectedRoute isAuth={isAuthenticated}><Settings /></ProtectedRoute>} />
    <Route path="/privacy" element={<PrivacyPolicy />} />
    <Route path="/terms" element={<TermsOfUse />} />
  </Routes>
);

export default AppRoutes;
